import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import avtar1 from '../../assets/images/user/avatar-1.jpg'
import { deleteData, getData, imgUrl } from '../Services/api'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import Pagination from '../Services/Pagination'
import Reply from './Reply'

const SupportList = () => {
    const [support, setSupports] = useState([]);
    const [selectedHelp, setSelectedHelp] = useState(null);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0)

    const fetchSupportRequests = async () => {
        try {
            const res = await getData('/support/message-list');
            if (res.status) {
                setSupports(res.data || [])
                setPage(res.pagination.page);
                setPages(res.pagination.pages);
                setTotal(res.pagination.total);
            }
        } catch (error) {
            console.log("error fetch suppoet request", error)
        }
    }

    useEffect(() => {
        fetchSupportRequests(page);
    }, [page]);
    
    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            fetchSupportRequests(pageNumber);
        }
    };

    const handleDelete = (helpId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/support/delete-message/${helpId}`,);
                    if (res.status) {
                        toast.success(res.message);
                        fetchSupportRequests();
                    }
                } catch (error) {
                    console.log("error delete help request", error)
                }
            }
        });
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/support/support-list">Help & Support</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Help & Support
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Help & Support</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>User Details</th>
                                                    <th>message</th>
                                                    <th>Created At</th>
                                                    <th>Replied At</th>
                                                    <th>Reply</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {support?.length > 0 ? (
                                                    support?.map((help, index) => {
                                                        return (
                                                            <tr key={help._id}>
                                                                <td>{index + 1 + (page - 1) * 10}.</td>
                                                                <td>
                                                                    <div className="row">
                                                                        <div className="col-auto">
                                                                            <img
                                                                                src={help?.userId?.profileImage ? `${imgUrl}${help?.userId?.profileImage}` : avtar1}
                                                                                alt="user-image"
                                                                                className="wid-40 rounded-circle"
                                                                            />
                                                                        </div>
                                                                        <div className="col">
                                                                            <h6 className="mb-0">{help?.userId?.fullname}</h6>
                                                                            <p className="text-muted f-12 mb-0">
                                                                                {help?.userId?.email}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{help.message}</td>
                                                                <td>{help?.createdAt?.split('T')[0]}{", "}{new Date(help?.createdAt)?.toLocaleTimeString()}</td>
                                                                <td>
                                                                    {help.repliedAt ? (
                                                                        <>
                                                                            {help.repliedAt.split('T')[0]}{", "}
                                                                            {new Date(help.repliedAt).toLocaleTimeString()}
                                                                        </>
                                                                    ) : (
                                                                        <span className="text-muted">Not Replied</span>
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    {help?.reply ? (
                                                                        <p>{help.reply}</p>
                                                                    ) : (
                                                                        <a
                                                                            href="#"
                                                                            className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#customer-edit_add-modal"
                                                                            onClick={() => setSelectedHelp(help._id)}
                                                                        >
                                                                            <i className="fas fa-reply f-18"></i>
                                                                        </a>
                                                                    )}

                                                                </td>

                                                                <td>
                                                                    {help.isResolved ? (
                                                                        <span className="badge bg-success">Resolved</span>
                                                                    ) : (
                                                                        <span className="badge bg-warning">Pending</span>
                                                                    )}
                                                                </td>
                                                                <td className="text-center">
                                                                    <ul className="list-inline me-auto mb-0">
                                                                        <li
                                                                            className="list-inline-item align-bottom"
                                                                            data-bs-toggle="tooltip"
                                                                            title="Delete"
                                                                        >
                                                                            <a
                                                                                onClick={() => handleDelete(help._id)}
                                                                                className="avtar avtar-xs btn-link-danger btn-pc-default"
                                                                            >
                                                                                <i className="fas fa-trash f-18" />
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={7} className='text-center'><strong>No Request Found.</strong></td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                        <div className="text-muted">
                                            Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                                        </div>
                                        <Pagination
                                            page={page}
                                            pages={pages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Reply model */}
            <Reply
                helpId={selectedHelp}
                onSuccess={() => {
                    fetchSupportRequests();
                    setSelectedHelp(null);
                }}
            />

        </>
    )
}

export default SupportList